module.exports = __webpack_public_path__ + "img/red_blob.183e90d8.png";